module.exports = __webpack_public_path__ + "img/pp_39.12f1649c.png";